<template>
  <div style="height: 100%;">
    <!--楼顶给排水-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>压力变速器</span>
    </div>
    <div style="overflow-y: auto; height: 84%;margin-top: 4%">
      <no-data style="margin-top: 20%;" v-if="data.length < 1"></no-data>
      <span :key="item.id" v-else v-for="(item,index) in data">
        <div style="margin-bottom: 4%;border: 1px solid rgba(41, 159, 251, 0.2);width: 90%;margin: 0px 0px 15px 20px;padding-top: 3%">
         <span style="font-weight: bold;font-size: 1rem;margin-left: 9%">{{item.deviceMeasuringPointHistoryList[0].deviceName }}</span>
          <span style="font-weight: bold;font-size: 1rem;float: right;margin-right: 6%" :style="{color:item.status === 0 || item.status === 2 ? '#00D488':'#F95453'}">
            <div style="width: 6px;height: 6px;opacity: 1;border-radius: 10px;margin-bottom: 1%;
            display: inline-flex;" :style="item.status === 0 || item.status === 2 ? 'background: rgba(0, 212, 136, 0.39)' : 'background:rgba(249, 84, 83, 0.39)'"></div>
            {{ item.status === 0 || item.status === 2 ? '通讯正常' : '通讯异常' }}</span>
          <el-row style="padding: 23px 0 10px 46px;">
        <el-col :span="6" style="margin-top: -1%;margin-right: 8%">
          <img style="width: 55%" src="../../../assets/images/comprehensive/压力变送器.png">
        </el-col>
       <el-col id="test" :span="10" style="position: relative;margin-left: -12%">
         <span :key="it.pointCode" v-for="it in item.deviceMeasuringPointHistoryList">
            <span v-if="it.pointCode == 'dw'" style="font-weight: bold;font-size: 18px;position: absolute;top: 20%;color: #00D488">
              <span v-if="it.pointCode == 'dw'" style="font-size: 1px;color: #FFFFFF;opacity: 60%">压力单位:
              </span>{{it.pointValueName}}</span>
            <span v-if="it.pointCode == 'yl'" style="position: absolute;top: 21px;font-size: 1px;color: #FFFFFF;opacity: 60%">测量值:
            <span v-if="it.pointCode == 'yl'" style="font-weight: bold;font-size: 18px" :style="{color: it.pointValue <= pressureAlarmHigh[index] && it.pointValue >= pressureAlarmLow[index] ? '#00D488' : '#F95453'}">{{it.pointValue}}</span>
            </span>
           </span>
        </el-col>
      </el-row>
          </div>
      </span>
    </div>

  </div>
</template>

<script>
import NoData from "@/components/NoData";
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import {listByDeviceId} from "@/network/device-measuring-point";

export default {
  name: "Pressure",
  components: {NoData},
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId() {
      this.data = []
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      data: [],
      video: [],
      typeList: ["PM_Pressure"],
      pointCodes: [],
      value:'0',
      // pressureAlarmHigh:0,
      pressureCode:'yl',
      pressureAlarmHigh:[],
      pressureAlarmLow:[]
    }
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getPressure:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getPressure')
  },
  methods: {
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.data = []
            res.data.forEach(item => {
              item.deviceInfoList.forEach(deviceInfo => {
                listByDeviceId(deviceInfo.id).then(result => {
                  if(result.code === 0){
                    if (result.data.length > 0) {
                      result.data.forEach(it =>{
                        if(it.code === this.pressureCode){
                          // this.pressureAlarmHigh=it.alarmHigh
                          // deviceInfo.pressureAlarmHigh = it.alarmHigh
                          this.pressureAlarmHigh.push(it.alarmHigh)
                          this.pressureAlarmLow.push(it.alarmLow)
                        }
                      })
                    }
                  }
                })
                this.data.push(deviceInfo);
              })
            })
          }
        }
      })
    },
    change() {

    }
  }
}
</script>

<style scoped>

</style>
